import { useState } from "react";
import SEO from "../components/SEO"; // Add this import
import { addContactMessage } from "../firebase/firebase-functions";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.message.trim()) {
      setError("Please enter a message");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const result = await addContactMessage(formData);

      if (result.success) {
        setIsSubmitted(true);
        setFormData({ name: "", email: "", message: "" });

        // Reset success message after 5 seconds
        setTimeout(() => setIsSubmitted(false), 5000);
      } else {
        setError(result.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Add SEO component */}
      <SEO
        title="Contact Anjali Daswani - Collaborations, Bookings & Inquiries"
        description="Get in touch with singer-songwriter Anjali Daswani for music collaborations, live performance bookings, press inquiries, and general questions. Based in New York City."
        url="https://anjalidmusic.com/contact"
        keywords="contact Anjali Daswani, music collaborations, booking musician NYC, press inquiries singer songwriter, live performances, acoustic sets"
        // logSchema={true} // Enable during development to test schema
      />

      <div className="contact-page">
        {/* Hero Section */}
        <section className="contact-hero-section">
          <div className="container">
            <div className="contact-hero-content">
              <h1 className="contact-title text-gradient">Get in Touch</h1>
              <p className="contact-subtitle">
                Have a question, collaboration idea, or just want to say hello?
                I'd love to hear from you.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="contact-form-section">
          <div className="container">
            <div className="contact-content">
              <div className="contact-info">
                <h2>Let's Connect</h2>
                <p>
                  Whether you're interested in collaborations, bookings, or just
                  want to share your thoughts about my music, I'm always excited
                  to connect with fellow music lovers and creators.
                </p>

                <div className="contact-points">
                  <div className="contact-point">
                    <h3>Collaborations</h3>
                    <p>
                      Open to working with other artists, producers, and
                      songwriters
                    </p>
                  </div>
                  <div className="contact-point">
                    <h3>Bookings</h3>
                    <p>Available for live performances and acoustic sets</p>
                  </div>
                  <div className="contact-point">
                    <h3>General Inquiries</h3>
                    <p>Questions about my music, story, or anything else</p>
                  </div>
                </div>
              </div>

              <div className="contact-form-wrapper">
                {!isSubmitted ? (
                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Name (Optional)
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Your name"
                        disabled={isLoading}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email (Optional)
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="your.email@example.com"
                        disabled={isLoading}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message" className="form-label">
                        Message *
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="form-textarea"
                        placeholder="Tell me what's on your mind..."
                        rows="6"
                        required
                        disabled={isLoading}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn-primary submit-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Send Message"}
                    </button>

                    {error && <p className="error-message">{error}</p>}
                  </form>
                ) : (
                  <div className="success-message">
                    <div className="success-icon">✓</div>
                    <h3>Message Sent!</h3>
                    <p>Thanks for reaching out. I'll get back soon!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Social Media Section */}
        <section className="contact-social-section">
          <div className="container">
            <div className="social-content">
              <h2>Follow the Journey</h2>
              <p>Stay connected and see what I'm working on</p>
              <div className="social-links-grid">
                <a
                  href="https://www.instagram.com/anjyyx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-contact-link instagram"
                >
                  <div className="social-icon">📸</div>
                  <div className="social-info">
                    <h3>Instagram</h3>
                    <p>@anjyyx</p>
                  </div>
                </a>
                <a
                  href="https://www.tiktok.com/@anjali.daswani"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-contact-link tiktok"
                >
                  <div className="social-icon">🎵</div>
                  <div className="social-info">
                    <h3>TikTok</h3>
                    <p>@anjali.daswani</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
